<template>
  <div class="container-fluid">
    <div class="content-wrapper">
      <ErrorView v-if="errorStatus" />
      <router-view v-else></router-view>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import ErrorView from "@/views/Error/ErrorView.vue";
import { useErrorStore } from "@/store/error/error";
import { useMainStore } from "@/store/main/main";

export default {
  components: { ErrorView },
  computed: {
    ...mapState(useErrorStore, {
      errorStatus: (store) => store.status,
    }),
  },
  mounted() {
    this.closeSideBar();
  },
  methods: {
    ...mapActions(useMainStore, ["closeSideBar"]),
  },
};
</script>

<style lang="scss" scoped></style>
